<template>
    <div class="overlay-component">
        
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="less">
    .overlay-component {
        width: 100vw;
        height: 100vh;
        background-color: black;
        opacity: .7;
        position: fixed;
        left: 0px;
        top: 0px;
        z-index: 10;
    }
</style>